import {throttle} from './utils';

const labHeader = (() => {
  const announcementBar = document.querySelector('.vue-announcement-bar');
  const headerEl = document.querySelector('#header');
  // Hide header on scroll
  let prevScrollPos = 0;
  let scrollUpDistance = 0;
  const SCROLL_UP_THRESHOLD = 150;

  function toggleAnnouncementBar(currScrollPos) {
    if (!announcementBar || window.showAnnouncementScrollUp) return;

    if (currScrollPos > headerEl.offsetHeight / 2) {
      announcementBar.style.transform = 'translateY(-100%)';
      announcementBar.style.maxHeight = '0';
      announcementBar.style.overflow = 'hidden';
    } else if (currScrollPos === 0) {
      announcementBar.style.transform = 'translateY(0)';
      announcementBar.style.maxHeight = '50px';
      announcementBar.style.overflow = 'auto';
    }
  }
  const toggleHeader = throttle(() => {
    const currentScrollPos = window.pageYOffset;
    const isScrollingDown = currentScrollPos > prevScrollPos;

    if (
      !document.body.classList.contains('modal-open') &&
      isScrollingDown &&
      currentScrollPos > headerEl.offsetHeight / 2
    ) {
      scrollUpDistance = 0;
      document.documentElement.style.setProperty('--header-transform', 'translateY(-100%)');
    } else if (currentScrollPos <= 0 || scrollUpDistance >= SCROLL_UP_THRESHOLD) {
      scrollUpDistance = 0;
      toggleAnnouncementBar(currentScrollPos);
      document.documentElement.style.removeProperty('--header-transform');
    } else if (!isScrollingDown) {
      scrollUpDistance += prevScrollPos - currentScrollPos;
    }
    prevScrollPos = currentScrollPos;
  }, 100);

  window.addEventListener('scroll', toggleHeader);

  // Set wrapper height to push content below header - on resize
  const resizeObserver = new ResizeObserver(
    throttle(() => {
      document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
    }, 500)
  );

  // older browser support
  const toggleResize = throttle(() => {
    document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
  }, 500);

  if (window.ResizeObserver) {
    toggleResize();
    resizeObserver.observe(headerEl);
  } else {
    toggleResize();
    window.addEventListener('resize', toggleResize);
  }

  /**
   * CSS handles: panel open/close (via :has() hover), backdrop (::after), scroll-hide.
   * JS handles: sticky active parent — activated on panel enter, reset on leave.
   * This is needed to control active state of the parent menu (mega-menu-parent
   */
  let megaMenuCleanup = null;

  function initMegaMenu() {
    if (megaMenuCleanup) megaMenuCleanup();

    const panels = document.querySelectorAll('[data-mega-panel]');
    if (!panels.length) return;

    const ac = new AbortController();
    const {signal} = ac;

    panels.forEach((panel) => {
      // Activate first parent when panel is entered — not on page load
      panel.addEventListener(
        'mouseenter',
        () => {
          if (!panel.querySelector('[data-mega-parent].is-active')) {
            const firstParent = panel.querySelector('[data-mega-parent]');
            if (firstParent) firstParent.classList.add('is-active');
          }
        },
        {signal}
      );

      // Reset when panel is left so no phantom visible children remain
      panel.addEventListener(
        'mouseleave',
        () => {
          panel.querySelector('[data-mega-parent].is-active')?.classList.remove('is-active');
        },
        {signal}
      );

      // Reset when panel loses focus so no phantom visible children remain
      panel.addEventListener(
        'focusout',
        () => {
          // Defer so the new activeElement is set before we check
          setTimeout(() => {
            if (!panel.contains(document.activeElement)) {
              panel.querySelector('[data-mega-parent].is-active')?.classList.remove('is-active');
            }
          }, 0);
        },
        {signal}
      );

      panel.querySelectorAll('[data-mega-parent]').forEach((parent) => {
        parent.addEventListener(
          'mouseenter',
          () => {
            panel.querySelector('[data-mega-parent].is-active')?.classList.remove('is-active');
            parent.classList.add('is-active');
          },
          {signal}
        );

        parent.addEventListener(
          'focusin',
          () => {
            panel.querySelector('[data-mega-parent].is-active')?.classList.remove('is-active');
            parent.classList.add('is-active');
          },
          {signal}
        );
      });
    });

    megaMenuCleanup = () => {
      ac.abort();
      megaMenuCleanup = null;
    };
  }

  if (document.readyState !== 'loading') initMegaMenu();
  else document.addEventListener('DOMContentLoaded', initMegaMenu);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('[data-mega-panel]')) {
        initMegaMenu();
      }
    });
  }
})();

export default labHeader;
